import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { IRegistrationReceiptModel } from '../../interfaces/scheduler_interfaces';

export type RegistrationReceiptModel = ITypedModel<IRegistrationReceiptModel>;

angular.module('capability-ng-scheduler').factory(
  'ngRegistrationReceiptModel',
  () =>
    new Model<IRegistrationReceiptModel>({
      showReceipt: false,
      receiptData: []
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_receipt/models/registration_reciept_model.ts